import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import GooglePlusCircleFilledSvg from "@ant-design/icons-svg/es/asn/GooglePlusCircleFilled";
import AntdIcon from "../components/AntdIcon";
var GooglePlusCircleFilled = function GooglePlusCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GooglePlusCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  GooglePlusCircleFilled.displayName = 'GooglePlusCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(GooglePlusCircleFilled);